export const productFeatures = () => {
  if (document.querySelector('.product-features'))  {
    if (window.innerWidth >= 1000) {
      const buttons = document.querySelectorAll('.product-features__item-top');
      const bottoms = document.querySelectorAll('.product-features__item-bottom');
      const items = document.querySelectorAll('.product-features__item');

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          if (items[index].classList.contains('active')) {
            items[index].classList.remove('active');
            bottoms[index].style.maxHeight = '0px'
          } else {
            items.forEach(function (item, index) {
              item.classList.remove('active');
            })
            bottoms.forEach(function (item, index) {
              item.style.maxHeight = '0px'
            })

            items[index].classList.add('active');
            bottoms[index].style.maxHeight = `${bottoms[index].scrollHeight}px`

          }

        })
      })
    } else {
      const buttons = document.querySelectorAll('.product-features__item-top');
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
        })
      })
    }
  }

}